goog.provide("shadow.js.shim.module$$mui$material$styles");
goog.provide("module$shadow_js_shim_module$$mui$material$styles");
shadow.js.shim.module$$mui$material$styles = shadow.js.nativeProvides["@mui/material/styles"] = shadow$bridge("@mui/material/styles");
module$shadow_js_shim_module$$mui$material$styles.default = shadow.js.shim.module$$mui$material$styles;
